import React from 'react'
import * as pathname from './pathaname'
import { MODULES, GROUPS, METHOD } from '../../utils/constants/roles'
import Needs from '../../views/purchase-fuels/needs/Needs'
import ShoppingCart from '../../views/purchase-fuels/shopping-cart/ShoppingCart'
import Suppliers from '../../views/purchase-fuels/suppliers/Suppliers'
import Historic from '../../views/purchase-fuels/historic/Historic'
import Notifications from '../../views/purchase-fuels/notifications/Notifications'
import SuppliersProposal from '../../views/purchase-fuels/suppliers-proposal/SuppliersProposal'
import Summary from '../../views/purchase-fuels/summary/Summary'

const purchaseFuelRoutes = [
  {
    path: pathname.purchaseFuelPathname.SUMMARY,
    name: 'summary',
    element: <Summary />,
  },
  {
    path: pathname.purchaseFuelPathname.PURCHASES,
    name: 'needs',
    element: <Needs />,
  },
  {
    path: pathname.purchaseFuelPathname.SUPPLIERS_PROPOSAL,
    name: 'suppliers proposal',
    element: <SuppliersProposal />,
    role: {
      module: MODULES.PURCHASE_FUEL,
      group: GROUPS.PROPOSAL,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.purchaseFuelPathname.SHOPPING_CART,
    name: 'shopping cart',
    element: <ShoppingCart />,
    role: {
      module: MODULES.PURCHASE_FUEL,
      group: GROUPS.PROPOSAL,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.purchaseFuelPathname.HISTORIC,
    name: 'historic',
    element: <Historic />,
    role: {
      module: MODULES.PURCHASE_FUEL,
      group: GROUPS.MADE,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.purchaseFuelPathname.SUPPLIERS,
    name: 'suppliers',
    element: <Suppliers />,
    role: {
      module: MODULES.PURCHASE_FUEL,
      group: GROUPS.SUPPLIERS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.purchaseFuelPathname.NOTIFICATIONS,
    name: 'notifications',
    element: <Notifications />,
    role: {
      module: MODULES.PURCHASE_FUEL,
      group: GROUPS.NOTIFICATION,
      method: METHOD.GET,
    },
  },
]

export default purchaseFuelRoutes
